var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"size":"is-medium","icon-left":_vm.buttonIcon},on:{"click":function($event){return _vm.generateText(_vm.quoteTextname, _vm.outputNumber, _vm.genOptions)}}},[_vm._v(_vm._s(_vm.buttonMsg))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }